var render = function render(_c,_vm){return _c('div',{staticClass:"x-filter-no-items"},[_vm._t("default",function(){return [_vm._v("No Items available")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }